import { PromptStarter } from "@/types/lora";

export function promptStyles (subject = 'person', triggerWord?: string): PromptStarter[] 
{
  if(subject === 'product')
    return [
      {
        id: '1',
        name: 'Modern',
        image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/modern.png',
        prompt:
          `${triggerWord} placed on a pristine white pedestal. As the camera slowly rotates, dramatic studio lighting casts sharp, high-contrast shadows, accentuating the product\'s modern design. Suddenly, a beam of light illuminates the product from above, creating a halo effect and making it appear almost ethereal.`,
      },
      {
        id: '2',
        name: 'Mountains',
        image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/mountain.png',
        prompt:
          `A female mountaineer holding an ${triggerWord} at the summit of mount everest, professional advertisement photography`,
      },
      {
        id: '3',
        name: 'Urban',
        image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/urban.png',
        prompt:
          `A close-up shot of an ${triggerWord} product resting on a table in a vibrant, urban setting. The product is illuminated by a soft spotlight, making it the center of attention. As the camera slowly zooms in, the product\'s condensation glistens, emphasizing its freshness. A hand (with rings and cool tattoos) reaches in, smoothly picking up the bottle. The scene cuts to a quick sip, followed by the person\'s confident smile directly to the camera`,
      },
      {
        id: '4',
        name: 'Vintage',
        image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/vintage.png',
        prompt:
          `A ${triggerWord} product rests on a weathered wooden table in a cozy, sunlit farmhouse kitchen. Golden hour light streams through lace curtains, casting intricate shadows. As the camera pans, we see an elderly craftsman\'s hands gently polishing the product, emphasizing its timeless, vintage-inspired design.`,
      },
      {
        id: '5',
        name: 'Vibrant',
        image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/vibrant.png',
        prompt:
          `A ${triggerWord} takes center stage on a vibrant, color-blocked set. As upbeat music plays, the camera dances around the product, revealing bold patterns that seem to pulse with energy. Suddenly, confetti in complementary colors rains down, creating a joyful and dynamic scene that showcases the product\'s lively design.`,
      },
      {
        id: '6',
        name: 'Watercolor Style',
        image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/watercolor.png',
        prompt: `A painting of ${triggerWord} in a watercolor style, AQUACOLTOK`,
        loraModel: {
          id: 399,
          name: 'Watercolor Style',
          image: 'https://promptsclub.com/_next/image?url=https://prompz-bucket.s3.amazonaws.com/70710/Flux-Aquarell-Watercolor-Coffee.webp&w=256&q=75',
          trigger_word: 'AQUACOLTOK'
        }
      },
    ]

  else if(subject === 'pet') {
    return [
    {
      id: '1',
      name: 'Pop Art',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/pop-art.jpg',
      prompt:
        `a pop art style portrait of ${triggerWord} pet, andy warhol inspired, bold primary colors, halftone dot pattern, comic book aesthetics, retro 60s vibe, high contrast, silkscreen effect, geometric backgrounds, artsation trendsetter, iconic pet imagery, museum quality print`,
    },
    {
      id: '2',
      name: 'Cyberpunk Hologram',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/hologram.jpg',
      prompt:
        `a cyberpunk hologram of ${triggerWord} pet, neon lights, futuristic cityscape, digital art, glowing energy aura, steam-punk collar, artsation trends, hyper-detailed fur textures, vibrant color palette, 3D rendering, featured on behance, sci-fi inspired, floating interface elements`,
    },
    {
      id: '3',
      name: 'Games Of Thrones',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/games.jpg',
      prompt:
        `a regal portrait of ${triggerWord} pet as the Lord of Winterfell, dire wolf-inspired, iron throne backdrop, fur-lined collar, house sigil, medieval fantasy style, artsation trending, hyper-detailed armor, winter is coming atmosphere, HBO quality rendering, epic scale composition`,
    },
    {
      id: '4',
      name: '80\'s Cyberpunk',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/retro-cyberpunk.jpg',
      prompt:
        `a photo of a ${triggerWord} pet, style of 80s cyberpunk`,
    },
  ]
}
  else if(subject === 'style' || subject === 'character' || subject === 'font') {
    return [
    {
      id: '1',
      name: 'Man running',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/man.jpg',
      prompt:
        `a man running down a hill, in the style of ${triggerWord}`,
    },
    {
      id: '2',
      name: 'Coffee',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/coffee.jpg',
      prompt:
        `coffee cup, in the style of ${triggerWord}`,
    },
    {
      id: '3',
      name: 'Woman Working',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/woman.jpg',
      prompt:
        `a girl coding at her desk, in the style of ${triggerWord}`,
    },
    {
      id: '4',
      name: 'Basketball Group',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/basketball.jpg',
      prompt:
        `a group of three boys playing basketball, in the style of ${triggerWord}`,
    },
    ]
  }
  else
  return [
    {
      id: '1',
      name: 'Linkedin',
      image: 'https://prompz-bucket.s3.amazonaws.com/69699/K75qTqfHk_rcQSSYd5l24_f6c794f5aea6420e9558699983f70ee8.png',
      prompt:
        `8k linkedin professional profile photo of ${triggerWord} in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful`,
    },
    {
      id: '2',
      name: 'Dream Style',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/FLUX+1+Controlnets+Loras+Image.png',
      prompt:
        `A DJ ${triggerWord} with vinyl records for eyes and cassette tape hair, pnt style`,
      loraModel: {
        id: 398,
        name: 'Dream Style',
        image: 'https://promptsclub.com/_next/image?url=https://prompz-bucket.s3.amazonaws.com/70699/Point-Flux-ComfyUI-%25281%2529.png&w=256&q=75',
        trigger_word: 'pnt style'
      }
    },
    // {
    //   id: '3',
    //   name: 'Half Illustrated',
    //   image: 'https://prompz-bucket.s3.amazonaws.com/69705/udvdMiOyoHvk8uL6yKKNa_420d1600dc674a3f972ce7e91635e448.png',
    //   prompt:
    //     'In the style of TOK, a photo editorial avant-garde dramatic action pose of ${triggerWord} wearing 90s round wacky sunglasses pulling glasses down looking forward, in Seattle at sunset with a vibrant illustrated jacket surrounded by illustrations of flowers, smoke, flames, ice cream, sparkles, rock and roll',
    //   loraModel: {
    //     id: 334,
    //     name: 'Half Illustrated',
    //     image: 'https://prompz-bucket.s3.amazonaws.com/69705/udvdMiOyoHvk8uL6yKKNa_420d1600dc674a3f972ce7e91635e448.png',
    //     trigger_word: 'in the style of TOK'
    //   }
    // },
    // {
    //   id: '5',
    //   name: 'RDR2',   
    //   image: '/placeholder.svg?height=100&width=100',
    //   prompt: `@alex, video game screenshot in the style of RDRG`'
    // },
    {
      id: '6',
      name: 'Watercolor Style',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/FLUX+1+Text+to+Image.png',
      prompt: `A painting of ${triggerWord} in a watercolor style, AQUACOLTOK`,
      loraModel: {
        id: 399,
        name: 'Watercolor Style',
        image: 'https://promptsclub.com/_next/image?url=https://prompz-bucket.s3.amazonaws.com/70710/Flux-Aquarell-Watercolor-Coffee.webp&w=256&q=75',
        trigger_word: 'AQUACOLTOK'
      }
    },
    {
      id: '7',
      name: "80's Stylish",
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/old-style.jpg',
      prompt: `8k 80\'s portrait of ${triggerWord}, blue background, white pearl neckless, fashion model in oversized white clothes, official balmain editorial, dramatic lighting highly detailed, analog photo, overglaze, 80mm Sigma f/1.4 or any ZEISS lens`
    },
    {
      id: '8',
      name: "80's Cyberpunk",
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/retro-old.jpg',
      prompt: `a photo of ${triggerWord}, style of 80s cyberpunk`,
      loraModel: {
        id: 397,
        name: '80\'s Cyberpunk',
        image: 'https://promptsclub.com/_next/image?url=https%3A%2F%2Fprompz-bucket.s3.amazonaws.com%2F70688%2FFlux-80s-Cyberpunk-Example.webp&w=256&q=75',
        trigger_word: 'AQUACOLTOK'
      }
    },
    {
      id: '9',
      name: 'Fantasy',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/LiselW2Q9BmPRbw3Q6c99_1f05c133d62443039fd37f208087650b.png',
      prompt: `8k portrait of ${triggerWord}, d & d, fantasy, intricate, elegant, highly detailed, digital painting, artstation, concept art, matte, sharp focus, illustration, hearthstone, art by artgerm and greg rutkowski and alphonse mucha, 8k`
    },
    {
      id: '10',
      name: 'Psychedelic',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/ZSuDSsAJo3DaH-yaviO75_97a4c766f13645c6a1484f7067c6ae28.png',
      prompt: `8k portrait psychedelic portrait of ${triggerWord}, vibrant color scheme, highly detailed, in the style of romanticism, cinematic, artstation, moebius, greg rutkowski`
    },
    {
      id: '11',
      name: 'Garden Painting',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/FLUX+1+Text+to+Image+(2).png',
      prompt: `portrait of happy ${triggerWord} in the garden, beautiful face, intricate, tone mapped, ambient lighting, clouds, green leafs foreground, parrots, highly detailed, digital painting, concept art, sharp focus`
    },
    {
      id: '12',
      name: 'Jedi',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/FLUX+1+Text+to+Image+(3).png',
      prompt: `8k portrait of ${triggerWord} as a jedi, star wars revenge of the sith movie scene style, studio photography, volumetric lighting, smiling, realistic, 35mm, expressive, iconic, 8k concept art, photorealistic`
    },
    {
      id: '13',
      name: 'Baby',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/XpDlrkhNZcp4nvUbutSHI_2167cbc41efd41839de8c95fc99fdbb9.png',
      prompt: `8k portrait of ${triggerWord}, a toddler, wearing white puffer jacket, hyperrealistic toddler baby`
    },
    {
      id: '14',
      name: 'Video Frames',
      image: 'https://prompz-bucket.s3.us-east-1.amazonaws.com/FLUX+1+Text+to+Image+(4).png',
      prompt: `a 4x4 grid of frames, showing consecutive frames from a short video clip featuring ${triggerWord}`
    },
  ];
}